import {Component, OnInit, ViewChild} from '@angular/core';
import {CandidatesDataService} from '../candidates-data.service';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {Select2OptionData} from 'ng-select2';
import {Options} from 'select2';
import {SelectFieldsTable} from '../../../../jobboard/shared/select-fields.table';
import {DropdownDataTable} from '../../../shared/dropdown-data.table';
import {NgbAlert, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs';
import * as XLSX from 'xlsx';
import { NgForm } from '@angular/forms';


@Component({
    selector: 'app-candidates-list',
    templateUrl: './candidates-list.component.html',
    styleUrls: ['./candidates-list.component.scss'],
    providers: [SelectLocationTable, SelectFieldsTable, DropdownDataTable]
})
export class CandidatesListComponent implements OnInit {

    constructor(private candidatesService: CandidatesDataService,
                private locationSelect: SelectLocationTable,
                private selectFields: SelectFieldsTable,
                private dropdownData: DropdownDataTable,
                private modalService: NgbModal) {}

    panelOpenState: boolean = false;

    newStatus: boolean;
    closeResult: string;

    blacklistReason: string;

    private _success = new Subject<string>();
    private _error = new Subject<string>();

    successMessage = '';
    errorMessage = '';

    reason: string;

    staticAlertClosed = false;
    @ViewChild('selfClosingAlert', {static: false}) selfClosingAlert: NgbAlert;
    @ViewChild('selfClosingError', {static: false}) selfClosingError: NgbAlert;

    selectedDomain: String = "";
    Domains: any  = this.dropdownData.domains;

    departments = this.dropdownData.departments;

    subdomains: any;
    subDomainsArray: any = [];

    categories: any = [];
    categoriesArray: any = [];

    selectSubdomains: any = [];

    selected: any;

    finalCategories: any = [];

    selectedCategories: any;

    changeDomain(domain: any) { //Angular 11
        this.subdomains = this.Domains.find((dmn: any) => dmn.name == domain.target.value).subdomains; //Angular 11
        this.subdomains.forEach( subdomain => {
            this.subDomainsArray.push(subdomain.name);
        })
    }

    changeSubDomain(subdomain: any) { //Angular 11
        this.selected = subdomain;

        let entries = [];
        for (let entry of this.selected) {
            if (entries.indexOf(entry === -1)) {
                entries.push(entry);
            }
        }

        let newCat = [];
        for (var _i = 0; _i < entries.length; _i++) {
            var num = entries[_i];
            this.categories = this.Domains.find((dmn: any) => dmn.name == this.selectedDomain).subdomains.find((sbdmn: any) => sbdmn.name == num).categories; //Angular 11
            if (newCat.indexOf(this.categories === -1)) {
                newCat.push(this.categories );
            }
        }

        let allCat = [];
        for (var _i = 0; _i < newCat.length; _i++) {
            for ( var e = 0; e < newCat[_i].length; e++) {
                allCat.push((newCat[_i][e]));
            }
        }
        this.categoriesArray = allCat;
    }


    candidatesData: any = [];

    size: any = 3;
    page: number = 1;
    pageSizes = [3, 6, 9, 'Toate rezultatele'];

    public driverLic: Array<Select2OptionData>;
    public studiesOp: Array<Select2OptionData>;


    languages = this.selectFields.languages;


    public multiSelectOp: Options;


    filteredCandidates: any = [];
    totalElements: number;

    // --- Dropdown for country and city
    countries = this.locationSelect.Countries;
    cities: Array<any> = [];
    changeCountry(country: any) {
        this.cities = this.countries.find((cntry: any) => cntry.name == country.target.value).cities;
    }
    // --- End of dropdown for country and city

    openSmall(content) {
        this.modalService.open(content, {
            size: 'sm'
        });
    }

    candidate: any = {};

    sortingValues = this.dropdownData.candidatesSorting;



    candidatesCall() {
            if(this.candidate.city !== undefined && this.candidate.city !== null){
                if(this.candidate.city.length === 0){
                    this.candidate.city = '';
                }
            }

        this.candidate = {
            user_roles: undefined,
            firstName: this.candidate.firstName !== "" ? this.candidate.firstName : undefined,
            lastName: this.candidate.lastName !== "" ? this.candidate.lastName : undefined,
            email: this.candidate.email !== "" ? this.candidate.email : undefined,
            telephone: this.candidate.telephone !== "" ? this.candidate.telephone : undefined,
            userCountry: this.candidate.userCountry !== "" ? this.candidate.userCountry : undefined,
            city: this.candidate.city !== "" ? this.candidate.city : undefined,
            civilStatus: this.candidate.civilStatus !== "" ? this.candidate.civilStatus : undefined,
            gender: this.candidate.gender !== "" ? this.candidate.gender : undefined,
            userActivitySector: this.selectedDomain !== "" ? this.selectedDomain : undefined,
            userActivitySubSector: this.selectSubdomains !== null ? (this.selectSubdomains.length > 0 ? this.selectSubdomains: undefined) : undefined,
            category: this.selectedCategories !== "" ? this.selectedCategories : undefined,
            userDepartment: this.candidate.userDepartment !== "" ? this.candidate.userDepartment : undefined,
            regionOfInterest: this.candidate.regionOfInterest !== "" ? this.candidate.regionOfInterest : undefined,
            availabilityOfRelocation: this.candidate.availabilityOfRelocation !== "" ? this.candidate.availabilityOfRelocation : undefined,
            workPermissionInEu: this.candidate.workPermissionInEu !== "" ? this.candidate.workPermissionInEu : undefined,
            currentExperienceLevel: this.candidate.currentExperienceLevel !== "" ? this.candidate.currentExperienceLevel : undefined,
            desiredLevelOfJob: this.candidate.desiredLevelOfJob !== "" ? this.candidate.desiredLevelOfJob : undefined,
            jobType: this.candidate.jobType !== "" ? this.candidate.jobType : undefined,
            availableForWork: this.candidate.availableForWork !== "" ? this.candidate.availableForWork : undefined,
            currentJob: this.candidate.currentJob !== "" ? this.candidate.currentJob : undefined,
            studies: this.candidate.studies != "" ? this.candidate.studies : undefined,
            language: this.candidate.languages != "" ? this.candidate.languages : undefined,
            // allUserStudies: undefined,
            // foreignLanguage: [
            //     {
            //         language: "",
            //         level: ""
            //     }
            // ],
            driverLicense: this.candidate.driverLicense !== "" ? this.candidate.driverLicense : undefined,
            userAvailableForTraveling:  this.candidate.userAvailableForTraveling !== "" ? this.candidate.userAvailableForTraveling : undefined,
            userWorkProgram: this.candidate.userWorkProgram !== "" ? this.candidate.userWorkProgram : undefined,
            userWorkSpace: this.candidate.userWorkSpace !== "" ? this.candidate.userWorkSpace : undefined,
            physicalEffortAvailability: this.candidate.physicalEffortAvailability !== "" ? this.candidate.physicalEffortAvailability : undefined,
            weightLiftingAvailability: this.candidate.weightLiftingAvailability !== "" ? this.candidate.weightLiftingAvailability : undefined,
            workTemperature: this.candidate.workTemperature !== "" ? this.candidate.workTemperature : undefined,
            userCommute: this.candidate.userCommute !== "" ? this.candidate.userCommute : undefined,
            interestedInBonusSystem: this.candidate.interestedInBonusSystem !== false ? this.candidate.interestedInBonusSystem : undefined,
            mandatoryMealVoucher: this.candidate.mandatoryMealVoucher !== false ? this.candidate.mandatoryMealVoucher : undefined,
            mandatoryHolidayVoucher: this.candidate.mandatoryHolidayVoucher !== false ? this.candidate.mandatoryHolidayVoucher : undefined,
            mandatoryServiceCar: this.candidate.mandatoryServiceCar !== false ? this.candidate.mandatoryServiceCar : undefined,
            mandatoryHealthPackage: this.candidate.mandatoryHealthPackage !== false ? this.candidate.mandatoryHealthPackage : undefined,
            mandatoryFood: this.candidate.mandatoryFood !== false ? this.candidate.mandatoryFood : undefined,
            mandatoryAccommodation: this.candidate.mandatoryAccommodation !== false ? this.candidate.mandatoryAccommodation : undefined,
            coursesInTheCountry: this.candidate.coursesInTheCountry !== false ? this.candidate.coursesInTheCountry : undefined,
            coursesAboard: this.candidate.coursesAboard !== false ? this.candidate.coursesAboard : undefined,
            blackListed: this.candidate.blackListed
        }
        console.log(this.candidate, '-----Test----', this.candidate.city)
        this.candidatesService.listCandidatesFiltered(this.size, this.page, this.sort, this.order, this.candidate).subscribe(candidates => {
            this.filteredCandidates = candidates;
            this.totalElements = this.filteredCandidates.totalElements;
        }, error => {
        });

    }

    resetForm(filterForm: NgForm) {
        filterForm.resetForm();
        this.candidatesService.listCandidatesFiltered(this.size, this.page, this.sort, this.order, this.candidate).subscribe(candidates => {
            this.filteredCandidates = candidates;
            this.totalElements = this.filteredCandidates.totalElements;
        }, error => {
        });
    }

    sort: string;
    order: string;

    onPageChange(page: number) {
        this.page = page;
        this.candidatesCall();
    }

    onSizeChange(event: any) {
        this.size = event.target.value;
        if (this.size === 'Toate rezultatele') {
            this.size = this.totalElements;
        }
        this.page = 1;
        this.candidatesCall();
    }

    onSortChange(event: any) {
        this.sort = event.target.value;
        this.page = 1;
        this.candidatesCall();
    }

    onOrderChange(event: any) {
        this.order = event.target.value;
        this.page = 1;
        this.candidatesCall();
    }

    ngOnInit() {

        this.studiesOp = [
            {
                id: 'high_school',
                text: 'Liceu / Școală profesionala'
            },
            {
                id: 'college',
                text: 'Colegiu / Studii postliceala'
            },
            {
                id: 'faculty',
                text: 'Facultate'
            },
            {
                id: 'master',
                text: 'Masterat'
            },
            {
                id: 'MBA',
                text: 'MBA'
            },
            {
                id: 'doctorate',
                text: 'Doctorat'
            }
        ]

        this.driverLic = [
            {
                id: 'no',
                text: 'Fara'
            },
            {
                id: 'A',
                text: 'A'
            },
            {
                id: 'B',
                text: 'B'
            },
            {
                id: 'C',
                text: 'C'
            },
            {
                id: 'D',
                text: 'D'
            },
            {
                id: 'E',
                text: 'E'
            },
            {
                id: 'Tr',
                text: 'Tr'
            },
            {
                id: 'Td',
                text: 'Td'
            },
            {
                id: 'Tb',
                text: 'Tb'
            }
        ];

        this.multiSelectOp = {
            width: '100%',
            multiple: true,
            allowClear: true
        }

        this.candidatesCall();

        this._success.subscribe(message => this.successMessage = message);
        this._success.pipe(debounceTime(5000)).subscribe(() => {
            if (this.selfClosingAlert) {
                this.selfClosingAlert.close();
            }
        });

        this._error.subscribe(message => this.errorMessage = message);
        this._error.pipe(debounceTime(5000)).subscribe(() => {
            if (this.selfClosingError) {
                this.selfClosingError.close();
            }
        });
    }

    public changeSuccessMessage(message: string) {
        this._success.next(message);
    }

    public changeErrorMessage(message: string) {
        this._error.next(message);
    }

    type: string = 'user';
    candidateBody: any;

    changeStatus(candidateId: string, candidateName: string, candidateLastName: string, blacklisted: boolean, reason: string, type: string){

        this.candidateBody = {
            userId: candidateId,
            companyId: 'string',
            reason: reason,
            type: type,
            id: 'string',
            userTitle: 'client',
            addedBy: 'string',
            addedDate: "2021-04-28T12:59:18.114Z"
        }

        if (blacklisted === false) {
            this.candidatesService.addToBlackList(this.candidateBody).subscribe(resp =>
            {
                this.candidatesCall();
                this.changeSuccessMessage('Candidatul cu numele ' + candidateName + ' a fost adaugat in blacklist!');
                this.reason = undefined;

            }, error => {
                this.changeErrorMessage('Eroare! Statusul nu a fost schimbat!');
                this.reason = undefined;


            });
        } else if (blacklisted === true) {
            this.candidatesService.deleteFromBlackList(candidateId, type).subscribe(resp =>
            {
                this.candidatesCall();
                this.changeSuccessMessage('Candidatul cu numele ' + candidateName + ' a fost scos din blacklist!');
                this.reason = undefined;


            }, error => {
                this.changeErrorMessage('Eroare! Statusul nu a fost schimbat!');
                this.reason = undefined;


            });
        }
    }

    /*name of the excel-file which will be downloaded. */
    fileName= 'ABJ-Lista-Candidati.xlsx';

    exportexcel(): void
    {
        /* table id is passed over here */
        let element = document.getElementById('candidatesTable');
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.fileName);

    }

}
